import React from 'react';
import { EMOJIS } from '../utils/utils';

const MessageReactions = ({ message, currentUserId, onToggleReaction }) => {
    if (!message.reactions || Object.keys(message.reactions).length === 0) return null;

    const reactionsObj = message.reactions || {};
    const reactionValues = Object.values(reactionsObj);
    const reactionCounts = reactionValues.reduce((acc, emojiId) => {
        acc[emojiId] = (acc[emojiId] || 0) + 1;
        return acc;
    }, {});

    const userReaction = message.reactions ? message.reactions[currentUserId] : null;

    return (
        <div className={`relative flex space-x-2 items-center z-50 ${message.audioUrl ? "-mt-7" : message.imageUrl || message.videoUrl ? "-mt-9" : "-mt-2"
            }`}>
            {Object.entries(reactionCounts).map(([emojiId, count]) => {
                const emojiData = EMOJIS.find((e) => e.id === emojiId);
                if (!emojiData) return null;
                return (
                    <span
                        key={emojiId}
                        onClick={() => onToggleReaction(message.id, emojiId, userReaction)}
                        className="flex items-center space-x-1 px-2 py-1 rounded-full text-xs transition bg-white dark:bg-gray-800 cursor-pointer"
                    >
                        <span className="text-sm">{emojiData.char}</span>
                        {count > 1 && (
                            <span className="ml-1 text-xs text-gray-700 dark:text-gray-200">
                                {count}
                            </span>
                        )}
                    </span>
                );
            })}
        </div>
    );
};


export default MessageReactions;